import PptxGenJS from 'pptxgenjs';
import { BASE_URL } from '@/config';
import { LAYOUT, COLORS, FONTS } from '../helpers/constants';
import {
    addConfidentialDisclaimer,
    addProjectBadge,
    addSlideTitle,
    regularSlideGradient
} from '../template-parts';
import { PPTImageManager } from '../helpers/image-manager';
import { orderTechnologies } from '@/helpers';

interface ExecutiveSummaryData {
    id: string;
    name: string;
    executiveSummary: string;
    projects: any;
    technologies: any;
}

const WIDTH = LAYOUT.width;
const HEIGHT = LAYOUT.height;
const MARGIN = LAYOUT.margin;

export function executiveSummarySlide(pptx: PptxGenJS, data: ExecutiveSummaryData, imageManager: PPTImageManager) {

    const { id: opportunityId, name, executiveSummary, projects, technologies } = data
    const slide = pptx.addSlide();
    const opportunityURL = `${BASE_URL}/opportunities/${opportunityId}`;
    const logoBlack = imageManager.get('logo-black');

    const technologyTypes = technologies.types || [];

    // Background gradient
    regularSlideGradient(slide);

    // Dark green section
    slide.addShape(pptx.ShapeType.rect, {
        x: 0,
        y: HEIGHT * 0.5,
        w: WIDTH,
        h: HEIGHT * 0.5,
        fill: { color: COLORS.primary },
        line: { type: 'none' },
    });

    if (logoBlack) {
        slide.addImage({
            data: logoBlack,
            x: 5.26,
            y: 0.24,
            w: 1.92,
            h: 0.58,
        });
    }

    // === 3) Badge PROJECT XXX
    addProjectBadge(slide, name);

    // === 4) Title About the seller ===
    addSlideTitle(slide, 'Executive Summary');

    // === 4.1) Content
    slide.addText(executiveSummary, {
        x: MARGIN,
        y: 1.4,
        w: 6.29,
        h: 3.34,
        fontFace: FONTS.body,
        fontSize: 12,
        bold: false,
        align: 'left',
        valign: 'top'
    })

    // === 5) Badge "MORE PROJECTS DETAILS HERE" ===
    slide.addText('MORE PROJECTS DETAILS HERE', {
        x: 2.25,
        y: 5.2,
        w: 3.14,
        h: 0.45,
        shape: pptx.ShapeType.roundRect,
        fontFace: FONTS.title,
        fontSize: 12,
        bold: true,
        color: COLORS.white,
        align: 'center',
        valign: 'middle',
        fill: { color: COLORS.accent },
        rectRadius: 0.1,
        hyperlink: { url: opportunityURL }
    });

    // === 6) Project numbers and tech icons ===
    technologyTypes.map((tech: string, i: number) => {
        const technologyIcon = imageManager.get(`icon-${tech}-green`) as string;
        slide.addImage({
            data: technologyIcon,
            x: 5.50 + i * 0.41,
            y: 5.87,
            w: 0.41,
            h: 0.41,
            sizing: { type: 'contain', w: 0.41, h: 0.41 }
        });
    });


    const projectsQuantity = projects.length;
    const numberOfProjectText = projectsQuantity > 1 ? `${projectsQuantity} Projects` : `${projectsQuantity} Project`;

    slide.addText(numberOfProjectText, {
        x: 5.63,
        y: 6.59,
        w: 1.5,
        h: 0.31,
        fontFace: FONTS.body,
        fontSize: 16,
        bold: false,
        color: COLORS.white,
        align: 'center',
        valign: 'middle',
    });

    slide.addText(technologies.capacity ?? "XX MWp", {
        x: 5.63,
        y: 6.32,
        w: 1.45,
        h: 0.31,
        fontFace: FONTS.body,
        fontSize: 16,
        bold: true,
        color: COLORS.lightPrimary,
        align: 'center',
        valign: 'middle',
    });

    // Confidential disclaimer
    addConfidentialDisclaimer(slide);
}
